import { useCallback, useMemo, useState } from 'react';

import * as columnDefs from '../../../../../components/AGGrid/config/columns-def';
import {filterCriteria} from "../../../../../utils/filterCriteria";

export function useTagsGridUtils({
                                         datastageApi,
                                         filterForm,
                                     defaultFilterRange,
                                         updateTags,
                                     handlers
                                     }) {
    const [sortedColId, setSortedColId] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');

    const setSort = useCallback(
        async (colId, direction) => {
            setSortedColId(colId);
            setSortDirection(direction);
            handlers.setLoadingTrue();
            try {
                const data = await datastageApi.tags(
                    filterCriteria(filterForm, '', 'tags'),
                    defaultFilterRange,
                    [colId, direction.toUpperCase()]
                );
                updateTags({
                    tags: data?.content,
                    totalPages: data?.totalPages,
                    totalItems: data?.totalElements,
                    currentPage: data?.pageable?.pageNumber,
                    tagSort: [colId, direction.toUpperCase()]
                });
            } catch (error) {
                console.error('Error sorting tags:', error);
            } finally {
                handlers.setLoadingFalse();
            }
        },
        [filterForm, defaultFilterRange, updateTags, handlers]
    );

    const baseColumns = columnDefs['tags'](
        ...handlers.columnHandlers
    )['default'];

    const columns = useMemo(() => (
        baseColumns.map(col => ({
            ...col,
            headerComponentParams: {
                ...col.headerComponentParams,
                setSort,
                sortedColId,
                sortDirection,
            }
        }))
    ), [setSort, sortedColId, sortDirection, baseColumns]);

    return { setSort, columns };
}